import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isVMBusiness } from '../../utils/BrandUtils';

export const HelpMediaComponent = ({ mediaList = [] }) => (
  <div
    className={classnames({
      'c-media-vm-bib': isVMBusiness(),
    })}
  >
    {mediaList.map((media, index) => (
      <div className="c-media" key={`HelpMediaComponent_mediaList_${index}`}>
        <div className="c-media__thumb c-media__icon-help">{media.image}</div>
        <div className="c-media__body">
          <h3 className="c-media__heading">{media.heading}</h3>
          <p>{media.body}</p>
        </div>
      </div>
    ))}
  </div>
);

HelpMediaComponent.propTypes = {
  mediaList: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.element, PropTypes.node])
        .isRequired,
      heading: PropTypes.string.isRequired,
      body: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
    })
  ),
};
